import { useState } from "react";
import PortalNavbar from "@/components/feature/PortalNavbar";
import PortalFooter from "@/components/feature/PortalFooter";
import BackToTop from "@/components/feature/BackToTop";
import Seo from "@/components/feature/Seo";
import { hotRankList } from "@/mocks/portal";

const tabData = [
  { key: "hour", label: "24小时榜", base: 0 },
  { key: "week", label: "周榜", base: 100 },
  { key: "month", label: "月榜", base: 200 },
];

const schema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: "曝光导航 · 热门排行",
  description: "曝光导航热门排行综合讨论量、转载与搜索趋势，实时呈现娱乐热点热度风向。",
  inLanguage: "zh-CN",
};

export default function RankingsPage() {
  const [active, setActive] = useState("hour");
  const tab = tabData.find((t) => t.key === active) || tabData[0];

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="热门排行 - 曝光导航 · 娱乐热点热度榜"
        description="曝光导航热门排行综合讨论量、转载与搜索趋势，覆盖综艺影视音乐时尚等栏目，24小时榜、周榜、月榜一应俱全，把握最新热度风向。"
        keywords="热门排行,热点排行,娱乐热搜,热度榜,曝光导航"
        schema={schema}
      />
      <PortalNavbar />
      <main className="flex-1">
        <section>
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
            <nav aria-label="面包屑" className="mb-6 flex items-center gap-1.5 text-xs text-foreground-500">
              <a href="/" className="hover:text-primary-600">首页</a>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-800">热门排行</span>
            </nav>
            <div className="text-center">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-fire-fill" />
                热门排行
              </span>
              <h1 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">热点热度排行榜</h1>
              <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-foreground-600">
                综合讨论量、转载与搜索趋势实时生成，把握圈内最新热度风向。
              </p>
            </div>

            <div className="mt-8 flex justify-center">
              <div className="inline-flex items-center gap-1 rounded-full bg-background-100 p-1">
                {tabData.map((t) => (
                  <button
                    key={t.key}
                    type="button"
                    onClick={() => setActive(t.key)}
                    className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${
                      active === t.key ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:text-primary-600"
                    }`}
                  >
                    {t.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="mx-auto mt-8 max-w-3xl">
              <ol className="space-y-3">
                {hotRankList.map((h, i) => {
                  const heat = Number(h.heat.replace("万", "")) * 10000 + tab.base + i * 7;
                  return (
                    <li key={`${active}-${h.id}`}>
                      <a href="/latest" className="flex items-center gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:bg-background-100">
                        <span
                          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-heading text-lg font-bold ${
                            i < 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                          }`}
                        >
                          {i + 1}
                        </span>
                        <div className="flex-1">
                          <h3 className="text-base font-semibold text-foreground-950 line-clamp-1">{h.title}</h3>
                          <p className="mt-1 text-xs text-foreground-600">栏目：{h.category}</p>
                        </div>
                        <div className="flex shrink-0 flex-col items-end gap-1">
                          <span className="text-sm font-bold text-foreground-800">{(heat / 10000).toFixed(0)}万热度</span>
                          <span
                            className={`flex items-center gap-0.5 text-xs ${
                              h.trend === "up" ? "text-primary-600" : h.trend === "down" ? "text-secondary-700" : "text-foreground-400"
                            }`}
                          >
                            {h.trend === "up" && <i className="ri-arrow-up-line" />}
                            {h.trend === "down" && <i className="ri-arrow-down-line" />}
                            {h.trend === "flat" && <i className="ri-subtract-line" />}
                            {h.delta}
                          </span>
                        </div>
                      </a>
                    </li>
                  );
                })}
              </ol>
              <p className="mt-6 text-center text-xs text-foreground-500">
                热度榜单仅供参考，依据公开讨论信息综合生成，时段不同排序会有浮动。
              </p>
            </div>
          </div>
        </section>
      </main>
      <PortalFooter />
      <BackToTop />
    </div>
  );
}